import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { RECOMMENDATIONS_API } from '../../constants/central-api';
import store from '../../../store/store';

export interface VariantPerformanceData {
  conversions: number | null;
  total_conversions: number | null;
  conversions_rate: number | null;
  visitors: number | null;
  total_visitors: number | null;
  confidence_metrics: {
    statistical_significance: boolean;
    confidence_level: number;
    p_value: number;
    confidence_interval: [number, number];
    effect_size: number;
    test_conversion_rate: number;
    control_conversion_rate: number;
  } | null;
}

export default async function get_variant_performance_api_call(rec_id: string) {
  const accessToken = store.getState().user?.stats?.ai_tracker_access_token;

  if (!accessToken) {
    return false;
  }

  const requestInfo: RequestInfo = {
    url: `${RECOMMENDATIONS_API}/impact/get-variant-performance?rec_id=${rec_id}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const actionType = 'GET_VARIANT_PERFORMANCE';
  const customMsg = 'Variant performance data fetched successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    true,
    false,
    true
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }
  if (res?.actionType === actionType && response?.success === true) {
    if (response?.data === null) {
      return null;
    } else {
      return response?.data as VariantPerformanceData;
    }
  }
}
